export default () => ({
	legacy: false,
	strategy: "no_prefix",
	fallbackLocale: "nl",
	detectBrowserLanguage: false,
	fallbackWarn: false,
	messages: {
		nl: {
			error: {
				header: "Sorry, we kunnen de pagina die je zoekt niet weergeven.",
				main: "Sorry, deze pagina kon niet gevonden worden. Mogelijk bestaat deze pagina niet meer, of is ze verhuisd. Tikte je zelf het webadres in? Mogelijk staat er een foutje in. Corrigeer het en probeer opnieuw.",
				technical: {
					header: "Technical details",
					subtitle: "(This grey section is only visible during development)"
				},
				checkout: { brandNotAvailableInPostalCode: "De titel {0} is niet beschikbaar in je regio." }
			},
			businessHourContent: {
				closed: "Vragen, wijzigen of opzeggen?",
				open: "Telefonisch bestellen? Bel:"
			},
			productOverview: {
				title: "Kies jouw nieuwe tijdschrift",
				filterCategory: "Filter op categorie",
				filterType: "Filter op type",
				noResults: "Sorry! We kunnen niet vinden wat je zoekt.",
				results: "We waren op zoek naar",
				search: "Zoeken",
				clear: "Reset"
			},
			bestellen: { title: "Controleer je bestelling" },
			checkoutForm: { title: "Vul je gegevens in" },
			AppDurationSelector: { title: "Kortingsperiode" },
			AppProductSelector: { title: "Hoe wil je {0} lezen?" },
			orderForm: { title: "Vul je gegevens in" },
			promotionCode: {
				required: "Vul een code in",
				length: "De code moet 6 tekens lang zijn",
				alphanumeric: "De code mag alleen letters cijfers, streepjes bevatten",
				errorMessage: "De code is niet geldig",
				title: "Verzilver jouw ledenkorting",
				subtitle: "Vul je code in en bekijk de kranten en tijdschriften waar je korting op krijgt."
			},
			orderSummary: {
				uspTitle: "Waarom bestellen bij ons?",
				title: "Jouw keuze",
				subTitle: "Je profiteert nu van:"
			},
			dpg: { footerText: `© DPG Media {0} - alle rechten voorbehouden <br/>KvK-Nummer: 34172906<br/>BTW Nummer: NL810828662B01` },
			yourChoice: "Jouw keuze",
			total: "Totaal {0}",
			startingDateLabel: "Ingangsdatum",
			discountPeriod: "Kortingsperiode",
			asap: "Zo snel mogelijk",
			direct: "Direct",
			trialLabel: "Eenmalig",
			priceCartLabel: {
				month: "Per maand",
				year: "Per jaar",
				week: "Per week",
				issue: "Per nummer",
				magazine: "Per nummer",
				quarter: "Per kwartaal",
				"one-time": "Eenmalig",
				"semi-annual": "Per half jaar",
				annual: "Per jaar"
			},
			links: { productCardCta: "Bekijk aanbod" },
			cancelation: {
				"2pv": `Na {0} opzegbaar`,
				month: "{0} maanden"
			},
			AppPropositionPreview: { footerText: "{0} korting" },
			components: { basePromotionCode: {
				promotionCode: "Vul hier jouw code in",
				promotionCodePlaceholder: "Code",
				apply: "Claim je korting",
				isValidatingButtonText: "Code controleren..."
			} },
			marketingPages: {
				footer: {
					privacyPolicy: "Privacybeleid",
					cookiePolicy: "Cookiebeleid",
					privacySettings: "Privacy-instellingen"
				},
				newsletter: {
					emailPlaceholder: "jouw@email.nl",
					buttonText: "Aanmelden",
					successMessage: "Je bent succesvol ingeschreven voor de nieuwsbrief."
				},
				productSlider: {
					allCategories: "Alles ({0})",
					categoryWithCount: "{0} ({1})"
				},
				productAid: {
					intro: {
						startButton: "Start keuzetool",
						introImageAlt: "intro",
						likeIconAlt: "like",
						dislikeIconAlt: "dislike"
					},
					toStart: { selectButton: "Selecteren" },
					regionalNewspaper: "Krant uit je regio",
					results: {
						title: "De krant die bij je past",
						subtitle: "Je zoekt nieuws dat uitlegt hoe beleid, trends en keuzes samenhangen, met oog voor feiten en nuance.",
						yourMatch: "Jouw match",
						regionalTitle: "Kies je gratis regio krant",
						regionalSubtitle: "Lorum ipsum"
					},
					footer: {
						back: "terug",
						reset: "reset"
					},
					cardBody: {
						chooseRegion: "Kies je regio",
						readFree: "Lees gratis"
					}
				},
				error: { pageNotFound: "Page Not Found" }
			}
		},
		be: {
			dpg: { footerText: `© DPG Media NV <br/> Mediaplein 1<br/> 2018 Antwerpen<br/> BTW Nummer: 0432.306.234` },
			marketingPages: {
				newsletter: {
					emailPlaceholder: "jouw@email.be",
					buttonText: "Aanmelden",
					successMessage: "Je bent succesvol ingeschreven voor de nieuwsbrief."
				},
				productSlider: {
					allCategories: "Alles ({0})",
					categoryWithCount: "{0} ({1})"
				},
				productAid: {
					intro: {
						startButton: "Start keuzetool",
						introImageAlt: "intro",
						likeIconAlt: "like",
						dislikeIconAlt: "dislike"
					},
					toStart: { selectButton: "Selecteren" },
					regionalNewspaper: "Krant uit je regio",
					results: {
						title: "De krant die bij je past",
						subtitle: "Je zoekt nieuws dat uitlegt hoe beleid, trends en keuzes samenhangen, met oog voor feiten en nuance.",
						yourMatch: "Jouw match",
						regionalTitle: "Kies je gratis regio krant",
						regionalSubtitle: "Lorum ipsum"
					},
					footer: {
						back: "terug",
						reset: "reset"
					},
					cardBody: {
						chooseRegion: "Kies je regio",
						readFree: "Lees gratis"
					}
				},
				error: { pageNotFound: "Page Not Found" }
			}
		}
	}
});
